import { Injectable } from '@angular/core';
import { GungBackendFeatureService } from 'gung-common';
import { BackendRerouteService, Invoice } from 'gung-standard';
import { JeevesInvoiceActionConfigService } from 'gung-standard-jeeves';

@Injectable({
  providedIn: 'root'
})
export class CarLinerJeevesInvoiceActionConfigService extends JeevesInvoiceActionConfigService {
  base = [
    // {
    //   title: 'PDF',
    //   action: (item: Invoice) => this.backendRerouteService.reroute('download/invoice-pdf/' + item.id + '.pdf')
    // }
  ];

  constructor(
    protected backendRerouteService: BackendRerouteService,
    protected gungBackendFeatureService: GungBackendFeatureService
  ) {
    super(backendRerouteService, gungBackendFeatureService);
  }
}
